import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { useGetBrandQuery } from '../../api/brandApi';
import { BrandState } from './brandReducer';
import { createContext, useContext, useEffect, useState } from 'react';
import { BrandV2 } from '@dap/admin/types';

const useBrandStateSelector: TypedUseSelectorHook<{ brand: BrandState }> = useSelector;

export const useSelectedBrandKey = () => {
  return useBrandStateSelector(({ brand: { selectedBrandKey } }) => selectedBrandKey);
};

const BrandContext = createContext<BrandV2 | undefined>(undefined);

type BrandProviderProps = {
  children: React.ReactNode;
};

export function BrandProvider({ children }: BrandProviderProps) {
  const brandKey = useSelectedBrandKey();
  const getBrandQueryState = useGetBrandQuery(brandKey, { skip: !brandKey });
  const [data, setData] = useState<BrandV2>({
    ...getBrandQueryState.data,
  } as BrandV2);

  useEffect(() => {
    if (getBrandQueryState.status === 'fulfilled' && getBrandQueryState.data) {
      setData({
        ...getBrandQueryState.data,
      });
    }
  }, [getBrandQueryState.status, getBrandQueryState.data]);

  return <BrandContext.Provider value={data}>{children}</BrandContext.Provider>;
}

export const useBrand = (): BrandV2 => {
  const context = useContext(BrandContext);

  if (!context) {
    throw new Error('Cannot get brand');
  }

  return context as BrandV2;
};

export const useBrandState = () => {
  const brandKey = useSelectedBrandKey();
  const getBrandQueryState = useGetBrandQuery(brandKey, { skip: !brandKey });

  return getBrandQueryState;
};
